<template>
  <Container
    v-if="props.events.length"
    :title="$t('region.public.events.title')"
    tag="publicRegionEvents"
  >
    <div
      v-if="!currentEvents.length"
      class="list-group-item"
      v-text="$t('region.public.events.no_future_events')"
    />
    <EventPanel
      v-for="event in currentEvents"
      :key="event.id"
      class="list-group-item py-0"
      :event="event"
      :status="-1"
    />
    <div
      v-if="numberOfDisplayedPastEvents > 0 && pastEvents.length"
      class="list-group-item"
    >
      <h3 class="past-events-heading" style="margin: 0;">
        <button
          type="button"
          class="past-events-toggle"
          :aria-expanded="pastEventsExpanded ? 'true' : 'false'"
          @click="pastEventsExpanded = !pastEventsExpanded"
        >
          <span v-text="$t('region.public.events.past_title')" />
          <i
            class="fas"
            :class="pastEventsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-hidden="true"
          />
        </button>
      </h3>
    </div>
    <EventPanel
      v-for="event in pastEvents.slice(0, pastEventsExpanded ? numberOfDisplayedPastEvents : 0)"
      :key="event.id"
      class="list-group-item py-0"
      :event="event"
      :status="-1"
    />
    <ContainerButton
      v-if="numberOfDisplayedPastEvents < pastEvents.length && (numberOfDisplayedPastEvents === 0 || pastEventsExpanded)"
      variant="success"
      :text-key="numberOfDisplayedPastEvents ? 'globals.show_more' : 'region.public.events.load_past'"
      icon="fas fa-calendar"
      @click="loadPastEvents"
    />
  </Container>
</template>
<script setup>
import { defineProps, ref } from 'vue'
import Container from '@/components/Container/Container.vue'
import EventPanel from '@php/Modules/Event/components/EventPanel.vue'
import ContainerButton from '@/components/Container/ContainerButton.vue'

const props = defineProps({
  events: { type: Array, required: true },
})

const now = new Date()
const pastEvents = ref(props.events.filter(event => new Date(event.endDate) < now).reverse())
const currentEvents = ref(props.events.filter(event => new Date(event.endDate) > now))
const numberOfDisplayedPastEvents = ref(currentEvents.value.length ? 0 : 10)
const pastEventsExpanded = ref(true)

function loadPastEvents () {
  numberOfDisplayedPastEvents.value += 10
  pastEventsExpanded.value = true
}
</script>

<style scoped>
.past-events-heading {
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: bold;
  text-shadow: none;
}

.past-events-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
</style>
